var app = angular.module("leonardo");

var TemplateListActions = function($scope, $rootScope, $state, $http, ngDialog, AuthDataService, PermissionService,
                                   AccountUserService, NotificationService, TemplatesAuditService, AccountService,
                                   ConfigThemeService, FilterService, TemplateService, $timeout) {
  $scope.permissionService = PermissionService;
  $scope.authDataService = AuthDataService;
  $scope.templateMode = $state.current.templateMode ? $state.current.templateMode : 'property';
  $scope.accountUserService = AccountUserService;

  $scope.onboarding = ($state.current.name === 'onboarding');

  $scope.activeAcceptAll = false;

  $scope.onCreateClick = function() {
    if ((AccountService.getCollection().length > 1) && AuthDataService.isNotStaff()) {
      ngDialog.openConfirm({
        template: 'views/templates/dialog/account/select.html',
        controller: 'SelectAccountDialog',
        className: 'ngdialog-theme-default ngdialog-select-account',
        data: {
          permission: 'permission_add_template'
        }
      }).then(function (account) {
        if (account) {
          $timeout(function () {
            $scope.goCreate((account !== 'all') ? account : null);
          }, 100);
        }
      });
    }
    else {
      $scope.goCreate(AccountUserService.currentAccountUser.account);
    }
  };

  $scope.onCreateTriggerClick = function() {
    if ((AccountService.getCollection().length > 1) && AuthDataService.isNotStaff()) {
      ngDialog.openConfirm({
        template: 'views/templates/dialog/account/select.html',
        controller: 'SelectAccountDialog',
        className: 'ngdialog-theme-default ngdialog-select-account',
        data: {
          permission: 'permission_add_template'
        }
      }).then( ()=>{
        $timeout( function (account) {
          ngDialog.openConfirm({
            template: 'views/templates/dialog/template/add-trigger.html',
            controller: 'TemplateTriggerAddDialog',
            className: 'ngdialog-theme-default ngdialog-template-add',
            data: {
              template: null,
              action: 'create',
              follow_on: null,
              workflow: null,
              account: account
            }
          }).then(function(){
            $rootScope.$broadcast('template-trigger:created');
          });
        }, 200)
      });
    }
    else {
      ngDialog.openConfirm({
          template: 'views/templates/dialog/template/add-trigger.html',
        controller: 'TemplateTriggerAddDialog',
        className: 'ngdialog-theme-default ngdialog-template-add',
        data: {
          template: null,
          action: 'create',
          follow_on: null,
          workflow: null,
          account: AccountUserService.currentAccountUser.account
        }
      }).then(function(){
        $rootScope.$broadcast('template-trigger:created');
      });
    }
  };

  $scope.goCreate = function (account) {
    switch ($scope.templateMode) {
      case 'property':
        $state.go('property.templates.add');
        break;
      case 'owner':
        $state.go('owner-tasks.templates.add', {account: account});
        break;
      default :
        if ((AuthDataService.isAdmin() || AuthDataService.isWhiteLabelAdmin())) {
          $state.go('templates.add', {account: account});
        }
        else {
          ngDialog.openConfirm({
            controller: 'PortfolioPropertySelectorDialog',
            templateUrl: 'views/templates/dialog/portfolio/selector.html',
            data: {
              account: account
            }
          }).then(function(results) {
            $timeout(function () {
              if (results.type) {
                $state.go('templates.add', {account: account});
              }
              else {
                $state.go('templates.add', {account: account, properties: results.properties.join(','), portfolios: results.portfolios.join(',')});
              }
            }, 100);
          });
        }
        break;
    }
  };
  
  $scope.acceptAll = function () {
    if (!$scope.activeAcceptAll) {
      return;
    }
    if ($scope.auditPageIds.length === 0) {
      AccountUserService.acceptAllAudits({audits_ids: 'all'}).then(function () {
        NotificationService.notify('success', 'The changes will be accept in a few moments.');
        $rootScope.$broadcast('template-audits:updated');
      });
    }
    else {
      ngDialog.openConfirm({
        template: 'views/templates/dialog/template/accept-audit.html',
        controller: 'AuditDialog',
        data: {
          auditsPage: $scope.auditPageIds
        }
      }).then(function (ids) {
        AccountUserService.acceptAllAudits({audits_ids: ids}).then(function () {
          if (ids === 'all') {
            NotificationService.notify('success', 'The changes will be accept in a few moments.');
          }
          $rootScope.$broadcast('template-audits:updated');
        });
      });
    }
  };
  
  $scope.rejectAll = function () {
    if (!$scope.activeAcceptAll) {
      return;
    }
    if ($scope.auditPageIds.length === 0) {
      AccountUserService.rejectAllAudits({audits_ids: 'all'}).then(function () {
        NotificationService.notify('success', 'The changes will be reject in a few moments.');
        $rootScope.$broadcast('template-audits:updated');
      });
    }
    else {
      ngDialog.openConfirm({
        template: 'views/templates/dialog/template/reject-audit.html',
        controller: 'AuditDialog',
        data: {
          auditsPage: $scope.auditPageIds
        }
      }).then(function (ids) {
        AccountUserService.rejectAllAudits({audits_ids: ids}).then(function () {
          if (ids === 'all') {
            NotificationService.notify('success', 'The changes will be reject in a few moments.');
          }
          $rootScope.$broadcast('template-audits:updated');
        });
      });
    }
  };

  $scope.showDisableAll = function() {
    ngDialog.open({
      template: 'views/templates/dialog/template/disable.html',
      controller: 'ChangeStatusAllDialog',
      data: {
        disable: true
      }
    });
  };

  $scope.templateBulkImport = function () {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/template/sector.html',
      controller: 'SelectSectorDialog'
    }).then(function (sector) {
      var url = ConfigThemeService.generateURL('/api/2.0/templates/bulk-import-excel/?response_type=1&sector=');
      url += sector;
      $http.get(url, {responseType:'blob'}).then(function (response) {
        var reader  = new FileReader();
        reader.onloadend = function () {
          var downloadLink = angular.element('<a></a>');
          downloadLink.attr('href', reader.result);
          downloadLink.attr('download', 'Template.xlsx');
          downloadLink[0].click();
        };
        reader.readAsDataURL(response.data);
      });
    });
  };

  $scope.templateBulkExport = function () {
    let filters = {};
    let type = FilterService.getFilter('type');
    if (!type) {
      if ((AuthDataService.isAdmin() || AuthDataService.isWhiteLabelAdmin())) {
        angular.noop();
      }
      else {
        switch ($scope.templateMode) {
          case 'owner':
            type = TemplateService.TYPE_ACCOUNT_USER;
            break;
          case 'trigger':
            type = TemplateService.TYPE_TRIGGER;
            break;
        }
      }
    }

    filters.name__icontains = FilterService.getFilter('name__icontains');
    filters.subcategory = FilterService.getFilter('subcategory');
    filters.category = FilterService.getFilter('category');
    filters.status = FilterService.getFilter('status');
    filters.audit = FilterService.getFilter('audit');
    filters.type = type;
    filters.levels = FilterService.getFilter('levels');
    filters.recurrence_type = FilterService.getFilter('recurrence_type');
    filters.property_type = FilterService.getFilter('property_type');
    filters.account = FilterService.hasFilter('account_reports') ?
      FilterService.getFilter('account_reports') : AccountUserService.currentAccountUser.account;
    filters.property = FilterService.getFilter('property_reports');
    filters.managed_by = FilterService.getFilter('managed_by_reports');
    filters.group = FilterService.getFilter('group_reports');
    filters.portfolio = FilterService.getFilter('portfolio_reports');
    filters.property = FilterService.getFilter('property_reports');
    if ((AuthDataService.isAdmin() || AuthDataService.isWhiteLabelAdmin())) {
      filters.sector = FilterService.getFilter('sector');
    }
    ngDialog.openConfirm({
      template: 'views/templates/dialog/template/export.html',
      controller: 'TemplatesExportDialog',
      data: {
        filters: filters
      }
    }).then(function (options) {
      angular.forEach(options, function(value, key) {
        filters[key] = value;
      });
      TemplateService.bulkExport(filters).then(function () {
        NotificationService.notify('success', 'An email will be sent to you in a few moments.');
      });
    });
  };

  $scope.$on('template-audit-list:updated', function (event, activeAll, auditIds) {
    $scope.activeAcceptAll = activeAll;
    $scope.auditPageIds = auditIds;
  });
  
};

app.controller('TemplateListActions', ['$scope', '$rootScope', '$state', '$http', 'ngDialog', 'AuthDataService',
  'PermissionService', 'AccountUserService', 'NotificationService', 'TemplatesAuditService', 'AccountService',
  'ConfigThemeService', 'FilterService', 'TemplateService', '$timeout', TemplateListActions]);